import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  ViewChild,
  ElementRef,
  Input,
  EventEmitter,
  Output,
  Optional,
  OnDestroy,
} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { CommonService, NotifySummaryUpdateService } from '@app/shared/services';
import { TaskService } from '@app/shared/services/task/task.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ViewTemplateComponent } from '@app/shared/component/view-template/view-template.component';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { MatSelect } from '@angular/material/select';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'task-item-dialog',
  templateUrl: './task-item-dialog.component.html',
  styleUrls: ['./task-item-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // encapsulation: ViewEncapsulation.None
})
export class TaskItemDialogComponent implements OnInit, OnDestroy {
  @ViewChild('categoryInput', { static: false }) categoryInput: ElementRef;
  @ViewChild('templateItemDropdown') templateItemSelect: MatSelect;
  @Input() placeholder;
  @Input() transactionType;
  @Input() inlineComponent = false;
  @Output() changeCategoryEventEmitter = new EventEmitter();
  @Output() openEventEmitter = new EventEmitter();
  @Output() closeEventEmitter = new EventEmitter();

  userId;
  group_id;
  is_filter;
  stateObject;
  is_filter_name;
  searchText = '';
  linkedItems = [];
  showFooter = false;
  panelClass: string;
  loader = [1, 2, 3, 4];
  vaultStateObject$: any;
  subscription: Subscription = new Subscription();

  constructor(
    private notifySummaryUpdateService: NotifySummaryUpdateService,
    @Optional() private dialogRef: MatDialogRef<TaskItemDialogComponent>,
    private taskService: TaskService,
    private changeDetectionRef: ChangeDetectorRef,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    private vaultService: VaultStoreEffects,
    private loginService: LoginStoreEffects,
    private toastr: ToastrService,
    private _inboxService: InboxSettingsService,
    private commonService: CommonService,
    private cd: ChangeDetectorRef
  ) {
    this.vaultStateObject$ = this.vaultService.vaultObject;
    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.stateObject = item;
        this.cd.markForCheck();
      })
    );

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.userId = state?.data?.id;
          this.cd.detectChanges();
        }
      })
    );

    this.subscription.add(
      this.notifySummaryUpdateService.getMessage().subscribe((message) => {
        if (message?.text?.needToUpdateUI) {
          this.selectTaskItem(message.text.res);
        }
      })
    );
  }

  ngOnInit(): void {
    if (!this.inlineComponent && this.data?.isAccountLinked) {
      this.showFooter = true;
      this.subscription.add(
        this.taskService.getNotLinkedAccountItems(this.stateObject.userId ?? this.userId).subscribe(
          (res) => {
            if (res) {
              let finalList = [];
              res.forEach((element, index) => {
                let tempEllemt = {
                  ...element,
                  name: '',
                };
                tempEllemt.name = element.form_name;
                finalList.push(tempEllemt);
              });
              this.linkedItems = finalList;
              this.changeDetectionRef.detectChanges();
            }
          },
          (error: any) => {
            this.toastr.error('Error  occurred while getting linked items');
          }
        )
      );
    } else {
      this.subscription.add(
        this._inboxService.getAllForms(this.stateObject.userId ?? this.userId).subscribe(
          (res) => {
            if (res.data) {
              let finalList = [];
              res.data.forEach((element, index) => {
                let tempEllemt = {
                  ...element,
                  name: '',
                };
                tempEllemt.name = element.form_name;
                finalList.push(tempEllemt);
              });
              this.linkedItems = finalList;
              this.changeDetectionRef.detectChanges();
            }
          },
          (error: any) => {
            this.toastr.error('Error  occurred while getting linked items');
          }
        )
      );
    }
  }

  ngAfterViewInit() {
    if (this.inlineComponent) {
      this.templateItemSelect.open();
      this.subscription.add(
        this.templateItemSelect.openedChange.subscribe((opened) => {
          if (opened) {
            setTimeout(() => {
              const panel = this.templateItemSelect.panel.nativeElement as HTMLElement;
              panel.style.visibility = 'visible';
            });
          }
        })
      );
    }
  }

  editLinkedVaultUserForm() {
    this.searchText = this.data.linked_vault_user_form_name;
    this.data.linked_vault_user_form_id = null;
  }

  deleteLinkedVaultUserForm() {
    this.dialogRef.close({ delete: true });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getFormData(id) {
    if (this.stateObject && this.stateObject.forms) {
      return this.stateObject.forms.filter((form) => form.id == id);
    }
  }

  selectTaskItem(item) {
    const itemData = {
      item_fid: item.fid,
      item_id: item.id,
      item_name: item.form_name,
      update_date: item.updated_at,
    };
    if (!this.inlineComponent) this.dialogRef.close(itemData);
    if (this.inlineComponent) this.changeCategoryEventEmitter.emit(itemData);
  }

  searchItem(text) {}

  addFile(filter, name) {
    const dialogRef = this.dialog.open(ViewTemplateComponent, {
      data: {
        categoryType: 'vault',
        isLinked: true,
        is_linked_form_id: -1,
        Linked_form_name: this.data.name,
        is_filter: filter,
        is_filter_name: name,
      },
      panelClass: 'full-window-dialog',
      disableClose: true,
    });
  }

  // openDrawerEvent(categoryId, categoryName, event = null) {
  //   if (event?.group_id) {
  //     this.group_id = event?.group_id;
  //   } else {
  //     this.group_id = null;
  //   }
  //   this.commonService.toggle(true);
  //   this.drawerButtonClicked = true;
  //   this.is_filter = categoryId;

  //   this.is_filter_name = categoryName;
  //   this.cd.detectChanges();
  // }

  // openDrawerEventRegister(event) {
  // this.commonService.toggleTemplate(true);
  // this.drawerRegisterTemplateButtonClicked = true;
  // }

  // hideTemplate(event) {
  // this.drawerRegisterTemplateButtonClicked = false;
  // this.cd.detectChanges();
  // }

  closeDropDownEvent(event) {
    this.closeEventEmitter.emit(true);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
